<template>
    <div class="box">
      <form class="form" v-on:submit.prevent="handlePolicy">
        <AddPolicyFields />
        <div class="form-wrap form-submit">
            <div>
              <button type="submit" class="button" v-if="userRole == 1">
                Edit Policy
              </button>
            </div>
        </div>
      </form>
    </div>
</template>
<script>

import AddPolicyFields from '@/components/AddPolicyFields.vue'
import { CancellationMixin } from './CancellationMixin';

export default {
    name: 'CancellationEdit',
    mixins:[CancellationMixin],
    components: {
        AddPolicyFields,
    },
    data() {
        return {
            newPolicy: {},  
        }
    },
    methods: {
        handlePolicy()
        {
            this.newPolicy.handle_tag = 'edit';
            this.addPolicy(this.newPolicy)
        }
    },
    async mounted(){
        let policy_id = this.$route.params.id
        let policy_detail = await this.editPolicy(policy_id)
        if (policy_detail) {
            this.newPolicy = policy_detail.data
        }
    }
}
</script>